
import * as types from './types';
import { JSON_STRING, HttpClient, MHTTPCL } from '../../../../services/http/http-client';
import { releaseService } from '../../services/releases/releases.services'
import { setMainNavInactive } from '../../../../store/app/mutations';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
// Action Object for ReleasesCatalog. Import the types from releases/types.js and Invoke Actions from the Vuex Host Components.
import router from '../../../../router';
import R from 'ramda';
import { LoadedEnd } from '../../../../dt-plugins/advanced-search/load.model';
import { fetchPropertiesWithArgsFlat } from '../../../../utility/fp';
import { dtTaskService } from '../../../../dt-plugins/dt-task/dt-task-service';
import { wait } from '../../../../utility';
import { ConfirmationService, createConfirmResult } from '../../../../dt-plugins/confirmation/confirmation.service';
import { i18n } from '../../../../i18n';
const NavTabModule = getNavTabModule(types.ReleaseDetails, 'releaseDetails');

export const releasesCatalogActions = {

  async [types.ReleasesCatalogData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    commit(types.ReleasesCatalogData.SET.ALL, {
      releaseCatalogMetaDataLoading: true
    });
    const releaseCatalogMetaData = await HttpClient.mergeRequests([
      releaseService.costGeneralData(),
      releaseService.multiCurrencyCostManagement(),
      releaseService.releaseAdvancedSearchModalData(),
    ]);
    console.log("CATALOG META DATA");
    commit(types.ReleasesCatalogData.SET.ALL, {
      ...releaseCatalogMetaData,
      releaseCatalogMetaDataLoading: false
    });
  },
  async [types.ReleaseList.FETCH.ALL]({ commit, getters, dispatch }, payload) {

    const { start, row_count, searchType, str } = payload;
    console.log({ "payload": payload });

    if (searchType != 'none') {
      if (start == 0) {
        const releaseData = await releaseService.advanceReleaseSearch(searchType, payload, start, row_count);
        console.log("searchType != 'none'&& strt==0", releaseData);
        commit(types.ReleaseList.SET.ALL, {
          ...getters.releasesCatalogData,
          releases: releaseData.data.releases,
        });
      }
      else {
        const releaseListRes = await releaseService.advanceReleaseSearch(searchType, payload, start, row_count);

        console.log("searchType != 'none'&& strt==0", releaseListRes);

        if (releaseListRes.data?.releases?.length > 0) {
          commit(types.ReleaseList.SET.ALL, {
            ...getters.releases,
            releases: [
              ...getters?.releasesCatalogData?.releases ?? [],

              ...releaseListRes.data?.releases ?? []
            ]
          });
        } else {
          return LoadedEnd;
        }
      }
    } else if ((str && str.length > 0)) {
      const serviceArguments = {
        ...payload,

      };
      console.log({ "serviceArguments": serviceArguments });
      if (start == 0) {
        const releaseListRes = await releaseService.advanceReleaseSearch(searchType, payload, start, row_count);
        //commit(types.ProductList.SET.ALL, productListRes.data);
      }
      else {
        const releaseListRes = await releaseService.advanceReleaseSearch(searchType, payload, start, row_count);

        if (releaseListRes.data?.releases?.length > 0) {
          commit(types.ReleaseList.SET.ALL, {
            ...getters.releases,
            releases: [
              ...getters?.releasesCatalogData?.releases ?? [],

              ...releaseListRes.data?.releases ?? []
            ]
          });
        } else {
          return LoadedEnd;
        }
      }
    } else {

      console.log("SEARCH STRING EMPTY", payload, start)
      if (start == 0) {


        const releasesCatalogData = await releaseService.releasesInit();

        console.log("CATALOG DATA", releasesCatalogData);

        commit(types.ReleaseList.SET.ALL, releasesCatalogData.data);
      } else {

        const releasesCatalogData = await releaseService.getReleases(start);

        if (releasesCatalogData.data?.releases?.length > 0) {
          commit(types.ReleaseList.SET.ALL, {
            ...getters.releasesCatalogData,
            releases: [
              ...getters?.releasesCatalogData?.releases ?? [],

              ...releasesCatalogData.data?.releases ?? []
            ]
          });
        } else {
          return LoadedEnd;
        }
      }
    }


  },


  async [types.ReleaseList.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {

    const release = await releaseService.addNewReleases({ ...payload })

    const releaseDetails = await releaseService.getReleasesDetails(release.data.release_id)

    // getters.releasesCatalogData.releases.push(releaseDetails.data.release)

    commit(types.ReleaseList.SET.ALL, {
      ...getters.releasesCatalogData,
      releases: [
        releaseDetails.data.release,
        ...getters.releasesCatalogData.releases,
      ]
    });

    console.log("ADD RELEASE", releaseDetails)

    return release.data.release_id;

  },
  async [types.ReleaseList.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {

    const { itemID, colorPropertyName, colorPropertyValue, colorValue, colorName } = payload;
    console.log({ itemID, colorPropertyName, colorPropertyValue, colorValue, colorName })

    const mod = await MHTTPCL.modifyJSON(undefined, itemID, colorPropertyName, colorPropertyValue, 'l_releases');



    // getters.releasesCatalogData.releases.push(releaseDetails.data.release)

    commit(types.ReleaseList.SET.ALL, {
      ...getters.releasesCatalogData,
      releases: getters.releasesCatalogData.releases.map(e => {
        if (e.release_id == itemID) {
          return {
            ...e,
            [colorName]: colorValue,
            [colorPropertyName]: colorPropertyValue
          }
        }

        return { ...e }
      }),

    });



  },

  async [types.ReleaseList.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { release_id } = payload;

    commit(types.ReleaseList.SET.ALL, {
      ...getters.releasesCatalogData,
      releases: getters.releasesCatalogData.releases.filter(e => e.release_id !== release_id)
    });

    await releaseService.removeRelease(release_id);



    // const productListData = await HttpClient.modifyJSON(
    //   undefined,
    //   product_id,
    //   name,
    //   value,
    //   'l_products',
    // );


  },



  async [types.ReleaseDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload = {}) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    let { flag, release, reload } = payload;

    flag = typeof flag === 'boolean' ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = 'release_id';
    const itemName = 'release';
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = 'releaseDetails';
    const DetailsAction = types.ReleaseDetails;


    // Check Reload and prexisting Item Logic

    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true,
      }
    })

    // HTTP Req

    await dispatch(types.ReleaseDetails.FETCH.PARTIAL, {
      properties: [
        'getReleasesDetails',
        'getLinks',
        'releaseMatchedAccounts',
        'releaseDetailsTabOverview',
        'releaseDetailsTabText',
        'releaseDetailsTabProducts',
        'costTab',
        'otherIncomeTab',
        'releaseDetailsTabSales',
        'releasesInit'
      ], release_id: release.release_id,
      parallel: false,
    });

    // const detailsResponse = await HttpClient.mergeRequests([
    //   releaseService.getReleasesDetails(release.release_id),
    //   //releaseService.getReleaseInfo(release.release_id),
    //   releaseService.getLinks(release.release_id),
    //   releaseService.releaseMatchedAccounts(release.release_id),
    //   releaseService.releaseDetailsTabOverview(release.release_id),
    //   releaseService.releaseDetailsTabText(release.release_id),
    //   releaseService.releaseDetailsTabProducts(release.release_id),
    //   releaseService.costTab(release.release_id),
    //   releaseService.otherIncomeTab(release.release_id),
    //   releaseService.releaseDetailsTabSales(release.release_id),
    //   releaseService.releasesInit(),
    // ]);

    const detailsResponse = await dtTaskService.taskList(release.release_id, 'release')

    console.log("DETaIlS OF RESponSE", detailsResponse);


    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, release) => {
      return {
        ...release,
        ...detailsResponse.data,
        loading: false,
      }
    })
  },

  async [types.ReleaseDetails.FETCH.PARTIAL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { properties, release_id, parallel, setnull } = payload;
    console.log(":::::::::::::", "FETCH PARTIAL", { properties, release_id, parallel, setnull })
    await fetchPropertiesWithArgsFlat(NavTabHelper, releaseService, properties, [release_id], parallel, setnull);
  },


  ...NavTabModule.implementActions(
    'release_id',
    'releases/release_id/tab',
    'releases',
    () => router,
    'catalog',
    (value, key) => {

      // console.log("KEY::", key, "value::", value);
      return {
        title: (value.release.release_title) ? value.release.release_title : key,
        full_title: value?.release?.releases_title || key,
      }
    }
  ),

  async [types.ReleaseDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)


    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item } = payload
    const { release } = item;
    const { release_id } = release;


    console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(release_id, (selectedReleaseDetails) => {
      return {
        release: {
          ...selectedReleaseDetails.release,
          [name]: value,
        }
      }
    });

    const modifiedRelease = await MHTTPCL.modifyJSON('release_id', item.release_id, name, value, 'l_releases');

    if (name === 'release_date') {
      const display_flag = await releaseService.notice_on_change_release_date(release_id);
      console.log("display_flag", display_flag);
      if (display_flag.data.display === 1) {
        const confirmationResult = await ConfirmationService.createP({
          width: 376,
          body: i18n.t('release_date_dialogue'),
          results: [
            createConfirmResult({
              value: "No",
              text: i18n.t('no'),
              classes: ["ut-mt-0 ut-mb-0"],
            }),
            createConfirmResult({
              value: "Yes",
              text: i18n.t('yes'),
              classes: ["v1 ut-mt-0 ut-mb-0"],
            }),
          ],
        });
        if (confirmationResult === "Yes") {
          await releaseService.update_product_date_afterchange_release_date(item.release_id);
        }
      }
    }




    return modifiedRelease;
  },
  async [types.UPDATE_RELEASE_DETAILS_STATE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log({ "payload": payload });
    const { release_costs_total, product_costs_total, release_id } = payload;
    const details = await releaseService.costTab(release_id);
    NavTabHelper.updateSingleNavTabDetails(release_id, (selectedReleaseDetails) => {
      console.log('ssssssssssss');
      console.log({
        ...selectedReleaseDetails.release,
        ...details,
        product_costs_total: +product_costs_total,
        release_costs_total: +release_costs_total,
      });
      return {
        product_costs_total: +product_costs_total,
        release_costs_total: +release_costs_total,
        costs: details.data.costs
      }
    });
    console.log({ "getters": getters.releaseDetails });
  },


  async [types.Genres.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("types.ReleaseDetails.UPDATE.SINGLE", payload)


    const { name, value, item, release } = payload;
    const { release_id } = release;

    const key = 'genre_relation_id';
    const kVal = item[key];
    const table = 'genre_relations';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }


    NavTabHelper.updateSingleNavTabDetails(release_id, (selectedReleaseDetails) => {
      return {
        related_genres: selectedReleaseDetails.related_genres.map(e => {
          if (e.genre_relation_id == item.genre_relation_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    })

    const modifiedRelease = await MHTTPCL.modifyJSON(undefined, kVal, name, value, table)



  },

  async [types.RelatedLink.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("types.ReleaseDetails.UPDATE.SINGLE", payload)


    const { name, value, item, release } = payload;
    const { release_id } = release;

    const key = 'link_id';
    const kVal = item[key];
    const table = 'links';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }


    NavTabHelper.updateSingleNavTabDetails(release_id, (selectedReleaseDetails) => {
      return {
        links: selectedReleaseDetails.links.map(e => {
          if (e.link_id == item.link_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    })

    const modifiedRelease = await MHTTPCL.modifyJSON(undefined, kVal, name, value, table)

  },



  async [types.ReleaseArtist.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("types.ReleaseDetails.UPDATE.SINGLE", payload)


    const { name, value, item, release } = payload;
    const { release_id } = release;

    const key = 'relation_id';
    const kVal = item[key];
    const table = 'l_relations';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }


    NavTabHelper.updateSingleNavTabDetails(release_id, (selectedReleaseDetails) => {
      return {
        artists: selectedReleaseDetails.artists.map(e => {
          if (e.relation_id == item.relation_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    })

    const modifiedRelease = await MHTTPCL.modifyJSON(undefined, kVal, name, value, table)

  },

  async [types.Genres.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { release } = payload;
    const { release_id } = release;

    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: true,
      }
    });

    let newGenre = {}
    if (payload.hasOwnProperty('genre_id')) {
      newGenre = await releaseService.addReleaseGenre(release_id, payload.genre_id)
    }
    else {
      newGenre = await releaseService.releaseNewGenre(release_id, payload.genre_name)

    }

    console.log("Log: newGenre", newGenre);


    // const key = 'invoiceline_id';
    // const table = 'invoicelines';

    // let defaultQtyAssign = false;

    // for (let invoiceline of newInvoiceLine.data.invoicelines) {
    //   if (!invoiceline.qty) {
    //     defaultQtyAssign = true;
    //     await HttpClient.modify(
    //       key,
    //       invoiceline.invoiceline_id,
    //       'qty',
    //       '1',
    //       table
    //     );
    //   }
    // }

    // if (!defaultQtyAssign) {

    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        related_genres: newGenre.data.related_genres
      };
    })

    // } else {
    //   await dispatch(types.InvoiceLines.FETCH.ALL, { invoice });
    // }
    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: false,
      }
    });
  },

  async [types.Genres.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { genre_relation_id, release } = payload;
    const { release_id } = release;


    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {

        related_genres: selectedReleaseDetails.related_genres.
          filter(e => e.genre_relation_id != genre_relation_id)
      }
    })

    const deletedGenres = await releaseService.addRemoveGenre(release_id, payload.genre_id, genre_relation_id)
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },
  async [types.RelatedLink.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { release } = payload;
    const { release_id } = release;

    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: true,
      }
    });

    const newRelatedLink = await releaseService.addLink(payload.link_type, payload.link_description, payload.link, release_id)
    const newRelatedLinkList = await releaseService.getLinks(release_id)

    console.log("Log: newRelatedLink", newRelatedLink, newRelatedLinkList);




    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        links: newRelatedLinkList.data.links
      };
    })

    // } else {
    //   await dispatch(types.InvoiceLines.FETCH.ALL, { invoice });
    // }
    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: false,
      }
    });
  },
  async [types.RelatedLink.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { link_id, release } = payload;
    const { release_id } = release;


    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: false,
        links: selectedReleaseDetails.links.
          filter(e => e.link_id != link_id)
      }
    })

    const deletedLinks = await releaseService.deleteLink(link_id)
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },
  async [types.ManualMatch.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { release } = payload;
    const { release_id } = release;

    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: true,
      }
    });

    const newMatchedAccount = await releaseService.addReleaseAccountRelation(release_id, payload.account_id, payload.text02)
    const newMatchedAccountList = await releaseService.releaseMatchedAccounts(release_id)

    console.log("Log: newRelatedLink", newMatchedAccount, newMatchedAccountList);




    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        matched_accounts: newMatchedAccountList.data.matched_accounts
      };
    })

    // } else {
    //   await dispatch(types.InvoiceLines.FETCH.ALL, { invoice });
    // }
    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: false,
      }
    });
  },

  async [types.ManualMatch.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { relation_id, release } = payload;
    const { release_id } = release;


    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {

        matched_accounts: selectedReleaseDetails.matched_accounts.
          filter(e => e.relation_id != relation_id)
      }
    })

    const deletedLinks = await releaseService.removeReleaseAccountRelation(relation_id)
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },

  async [types.ReleaseArtist.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { release } = payload;
    const { release_id } = release;

    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: true,
      }
    });

    const newArtist = await releaseService.addSelectedArtists(release_id, payload.artists)
    const artistList = newArtist.data.artists;
    console.log("Log: newRelatedLink", artistList);




    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        artists: [...artistList]
      };
    })

    // } else {
    //   await dispatch(types.InvoiceLines.FETCH.ALL, { invoice });
    // }
    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: false,
      }
    });
  },

  async [types.ReleaseArtist.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { relation_id, release } = payload;
    const { release_id } = release;


    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {

        artists: selectedReleaseDetails.artists.
          filter(e => e.relation_id != relation_id)
      }
    })

    const deletedLinks = await releaseService.deleteReleaseArtist(relation_id)
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },


  async [types.RelatedFile.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { file_relation_id, release, file_id } = payload;
    const { release_id } = release;


    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {

        related_files: selectedReleaseDetails.related_files.
          filter(e => e.file_relation_id != file_relation_id)
      }
    })

    const deletedLinks = await releaseService.deleteDocumentRelation(file_id, file_relation_id)
    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },
  async [types.Cost.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("types.ReleaseDetails.UPDATE.SINGLE", payload)


    const { name, cost_split_id, hold_flag, release } = payload;
    const { release_id } = release;

    const table = (name == "related_costs") ? "costs" : "other_incomes";
    const hold_flag_value = (hold_flag == 'checked') ? 1 : null;


    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }

    const recoupable_txt = await releaseService.updateCostHoldflag(cost_split_id, hold_flag)
    console.log("WETY", recoupable_txt);

    NavTabHelper.updateSingleNavTabDetails(release_id, (selectedReleaseDetails) => {
      return {
        [`${table}`]: selectedReleaseDetails[table].map(e => {
          if (e.cost_split_id == cost_split_id) {
            return {
              ...e,
              ['hold_flag']: hold_flag_value,
              ['recoupable_txt']: recoupable_txt.data.recoupable_txt
            };
          } else {
            return e;
          }
        })
      }
    })



  },

  async [types.Cost.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { cost_split_id, release, name } = payload;
    const { release_id } = release;

    const table = (name == "related_costs") ? "costs" : "other_incomes";
    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {

        [`${table}`]: selectedReleaseDetails[table].
          filter(e => e.cost_split_id != cost_split_id)
      }
    })


    //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },

  async [types.ReleaseRelatedContacts.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("types.ReleaseDetails.UPDATE.SINGLE", payload)


    const { name, value, item, release } = payload;
    const { release_id } = release;

    const key = 'contact_relation_id';
    const kVal = item[key];
    const table = 'contact_relations';

    // const oldValue = item[name];
    // if (oldValue == value) {
    //   return;
    // }


    NavTabHelper.updateSingleNavTabDetails(release_id, (selectedReleaseDetails) => {
      return {
        contact_relations: selectedReleaseDetails.contact_relations.map(e => {
          if (e.contact_relation_id == item.contact_relation_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    })

    const modifiedRelease = await MHTTPCL.modifyJSON(undefined, kVal, name, value, table)

  },

  async [types.ReleaseRelatedContacts.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { contact, release } = payload;
    const { release_id } = release;
    const { contact_relation_id } = contact;

    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {

        contact_relations: selectedReleaseDetails.contact_relations.
          filter(e => e.contact_relation_id != contact_relation_id)
      }
    });

    const deletedContact = await releaseService.deleteContactRelation(contact_relation_id)


  },


  async [types.ReleaseRelatedContacts.SET.ALL]({ commit, getters, dispatch }, {
    contact_relations,
    external_table,
    external_id,
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(external_id, (_, selectedReleaseDetails) => {
      return {
        ...selectedReleaseDetails,
        contact_relations: contact_relations
      };
    })
  },

  async [types.RelatedProduct.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("TTTT", payload)
    const { format_id, related_product_id, catalog_no, barcode, release , alt_title,alt_artist ,product_date  } = payload;
    const { release_id } = release

    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: true,
      }
    });
    const newRelatedProduct = await releaseService.newRelatedReleaseProduct(catalog_no, format_id, related_product_id, release_id, barcode ,alt_title,alt_artist,product_date)
    const relatedProductList = await releaseService.loadReleaseRelatedProducts(release_id);
    console.log("Log: newRelatedLink", relatedProductList);




    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        related_products: relatedProductList.data.related_products
      };
    })


    NavTabHelper.updateSingleNavTabDetails(release_id, selectedReleaseDetails => {
      return {
        loading: false,
      }
    });

  },






  async [types.SET_RELEASE_PRODUCT_FILES]({ dispatch, getters }, { files, externalId, externalTable }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const release_id = externalId;
    NavTabHelper.setSingleNavTabDetails(release_id, (_, selectedReleaseDetails) => {
      return {
        ...selectedReleaseDetails,
        related_files: files,
      }
    });
  },

  async [types.SET_RELEASE_ARTWORK]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { selectedReleaseDetails, file, artworkKey } = payload;
    const { file_id } = file;
    const { release } = selectedReleaseDetails;
    const { release_id } = release;


    NavTabHelper.updateSingleNavTabDetails(release_id, (_) => {
      return {
        [artworkKey]: file.file_link,
      }
    });

    await MHTTPCL.modify(
      'release_id',
      release_id,
      artworkKey,
      file_id,
      'l_releases'
    );
  },


}


